import { Directive, HostListener } from '@angular/core';

/**
 * PrimeNG's `Accordion` attaches its Home/End keyboard navigation
 * (`onTabHomeKey`/`onTabEndKey`) as a `@HostListener('keydown')` on the whole
 * accordion element, not just the tab headers -- and unlike its
 * ArrowUp/ArrowDown handling it never checks whether a header is actually
 * focused before calling `event.preventDefault()` and jumping focus to the
 * first/last tab header. That swallows every Home/End press made while
 * editing any input inside a tab body, so the native caret-to-start/end
 * behavior never happens.
 *
 * Apply `appStopAccordionHomeEnd` to each `p-accordionTab`'s content wrapper
 * (or, when a tab's content is a single child component tag, directly on
 * that tag -- its host element is still inside the accordion's DOM subtree,
 * so this still catches events bubbling up from inputs in its template).
 * Stopping propagation there, before the event reaches the accordion's own
 * host element, restores native Home/End inside form fields. Header-to-header
 * Home/End navigation is untouched: `AccordionTab` invokes it via a direct
 * template binding on the header link itself, not by relying on bubbling.
 */
@Directive({
  selector: '[appStopAccordionHomeEnd]'
})
export class StopAccordionHomeEndDirective {
  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation();
    }
  }
}
